import { useState } from 'react';

import { Link } from 'react-router-dom';

import MoreIcon from '../../../../../assets/icons/MoreIcon';
import Translations from '../../../../../assets/locale/en/content.json';
import { GridMoreOptionsEnum } from '../../../../../common/enums/GridMoreOptionsEnum';
import { NavigationOptions } from '../../../../../common/interfaces/GridMoreOptionsConfig';
import { TngGrid, TngIconButton, TngList, TngListItem, TngPopover } from '../../../../common';

const MoreOption = (props: any) => {
  const { moreOptionNavigation } = props;
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl);

  const createAbsoluteUrl = (nav: NavigationOptions) => {
    let absoluteURL;
    // use switch case for eventType and then create url to navigate
    switch (nav.eventType) {
      // for view change the base url according to navigation props
      case GridMoreOptionsEnum.VIEW:
        absoluteURL = new URL(nav.navigationTo, window.location.origin);
        if (nav.navigationProps) {
          const value = props.data[nav.navigationProps];
          absoluteURL.searchParams.set(nav.navigationProps, value);
        }
        break;
      case GridMoreOptionsEnum.EDIT:
        // for edit, add edit=true as a params before adding to Id and don't change base url
        absoluteURL = new URL(window.location.href);
        absoluteURL.searchParams.set('edit', 'true');
        if (nav.navigationProps) {
          const value = props.data[nav.navigationProps];
          absoluteURL.searchParams.set(nav.navigationProps, value);
        }
        break;
      case GridMoreOptionsEnum.DUMMY:
        // for dummy just don't navigate to anywhere
        absoluteURL = new URL(window.location.href);
        break;
      default:
        // Code to execute if no case matches
        absoluteURL = new URL(nav.navigationTo, window.location.origin);
        if (nav.navigationProps) {
          const value = props.data[nav.navigationProps];
          absoluteURL.searchParams.set(nav.navigationProps, value);
        }
    }
    return absoluteURL;
  };

  return (
    <TngGrid className="more_option_container" style={{ position: 'relative' }}>
      <TngIconButton
        disableRipple
        disableFocusRipple
        onClick={handleClick}
        className="more_option_btn"
        role="button"
        data-testid="more-option-button"
        aria-label={Translations.orderHistory.moreOptionButton}
      >
        <MoreIcon height="18px" width="18px" />
      </TngIconButton>
      <TngPopover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        className="more_option_popup"
        data-testid="more-option-popup"
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <TngList className="more_option_list">
          {moreOptionNavigation.map((nav: NavigationOptions) => {
            const absoluteURL = createAbsoluteUrl(nav);
            return (
              <TngListItem key={nav.label} className="more_option_list_items">
                <Link to={absoluteURL.href}>{nav.label}</Link>
              </TngListItem>
            );
          })}
        </TngList>
      </TngPopover>
    </TngGrid>
  );
};

export default MoreOption;
